import React from 'react';
import useEnlog from 'app/hook/common/useEnlog';
import classNames from 'classnames/bind';
import styles from './ResponsiveTemplate.module.scss';

const cx = classNames.bind(styles);

/** TitleType: BoxType 밖에 있는 타이틀
 * 모바일형태 vs PC형태: margin, padding, border-top
 */
export const TitleType = ({
	children,
	// style 한번에?
}) => <div className={cx('title_type')}>{children}</div>;

/** BoxType: 흰색의 라운드박스
 * 모바일형태 vs PC형태: padding
 * type: top_line 상단에 간격과 라인이 있는 형태
 */
export const BoxType = (props) => {
	const { type = '', children } = props;
	const { propsDataset } = useEnlog();
	const dataSet = propsDataset(props);

	return (
		<div
			className={cx('box_type', type)}
			{...dataSet}
		>
			{children}
		</div>
	);
};

/** TextImageType: 텍스트와 이미지 형태
 * 모바일형태: 상하 정렬
 * PC형태: 좌우 정렬
 * reverse: area="wrap"에서만 유효. children 렌더 순서를 반전시킴, 기존 마크업 순서는 text → image이나, image를 text 위(앞)에 노출해야 하는 케이스에서 사용
 * 마크업구조
	<ResponsiveTemplate.TextImageType area="wrap">
		<ResponsiveTemplate.TextImageType area="text">
			텍스트
		</ResponsiveTemplate.TextImageType>
		<ResponsiveTemplate.TextImageType area="image">
			이미지
		</ResponsiveTemplate.TextImageType>
 		<ResponsiveTemplate.ButtonType>
 			버튼
 		</ResponsiveTemplate.ButtonType>
	</ResponsiveTemplate.TextImageType>
 */
export const TextImageType = (props) => {
	const { area, reverse, children } = props;
	const { propsDataset } = useEnlog();
	const dataSet = propsDataset(props);

	if (area === 'wrap') {
		const orderedChildren = reverse ? React.Children.toArray(children).reverse() : children;
		return (
			<div
				className={cx('text_image_type')}
				{...dataSet}
			>
				{orderedChildren}
			</div>
		);
	}
	if (area === 'text') {
		return <div className={cx('content_text')}>{children}</div>;
	}
	if (area === 'image') {
		return <div className={cx('content_img')}>{children}</div>;
	}
	return null;
};

/** ListType: 리스트 형태
 * 모바일형태: 상하 정렬
 * PC형태: 좌우 정렬
 * 마크업
	<ResponsiveTemplate.ListType area="wrap">
		제목등
		<ResponsiveTemplate.ListType area="list">
			리스트: ul,li의 마크업
		</ResponsiveTemplate.ListType>
		<ResponsiveTemplate.ButtonType>
 			버튼
		<ResponsiveTemplate.ButtonType>
	</ResponsiveTemplate.ListType>
 */
export const ListType = (props) => {
	const { area, children } = props;
	const { propsDataset } = useEnlog();
	const dataSet = propsDataset(props);

	if (area === 'wrap') {
		return (
			<div
				className={cx('list_wrap')}
				{...dataSet}
			>
				{children}
			</div>
		);
	}
	if (area === 'list') {
		return <div className={cx('list_type')}>{children}</div>;
	}
	return null;
};

/** ButtonType: 컨텐츠 하단에 가이드 버튼
 * 모바일형태 vs PC형태: width, margin
 */
export const ButtonType = ({ children }) => <div className={cx('button_type')}>{children}</div>;

const ResponsiveTemplate = {
	TitleType,
	BoxType,
	TextImageType,
	ListType,
	ButtonType,
};

export default ResponsiveTemplate;
